//Importación de librerias
//---------------SIQA---------------
//Catalogos
import C003TiposDeSentidoDeSentencia from '../../../src/components/SIQA/Comun/Catalogos/C003TiposDeSentidoDeSentencia.vue'


//Creamos y asignamos los datos necesarios de SIQA
const siqa = [
  { Proviene: 'SIQA', Nombre: 'C003TiposDeSentidoDeSentencia', datos: C003TiposDeSentidoDeSentencia }
]


//Exportamos los datos de SIQA
export default siqa;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/siqa.js
// module id = null
// module chunks = 